import { useEffect } from 'react';
import { useMediaQuery } from './useMediaQuery';

const GESTURES = ['gesturestart', 'gesturechange', 'gestureend'] as const;

/** Cancels Safari's proprietary pinch gesture events, so the page itself never zooms. */
export function useNoPageZoom(enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const prevent = (e: Event) => e.preventDefault();
    const opts = { passive: false } as const;
    for (const type of GESTURES) document.addEventListener(type, prevent, opts);
    return () => {
      for (const type of GESTURES) document.removeEventListener(type, prevent);
    };
  }, [enabled]);
}

/** Whether the app runs as an installed app (home screen), where no browser UI resets a zoom. */
export function useInstalledApp(): boolean {
  const standalone = useMediaQuery('(display-mode: standalone)');
  const legacy = (globalThis.navigator as (Navigator & { standalone?: boolean }) | undefined)
    ?.standalone;
  return standalone || legacy === true;
}
